/**
 * @desc 根据skuId获取sku详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlmSkuDetailInfoResponseDto>;
export function request(skuId: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/${skuId}`, {
      method: "GET",

      ...options,
    }),
  );
}
